/**
 * CHN Custom Mega Menu
 * Hover open/close, position tracking for sticky header, keyboard nav.
 * No panel switching — columns are always visible.
 */

class MegaMenuCustom extends HTMLElement {
  constructor() {
    super();
    this.menu     = this.querySelector('.mega-menu-custom');
    this.backdrop = this.querySelector('.mega-menu-custom__backdrop');
    this.trigger  = this.querySelector('.mega-menu-custom__trigger');
    this.isOpen   = false;
    this.closeTimeout = null;
  }

  connectedCallback() {
    if (!this.menu || !this.trigger) return;

    // Hover open/close
    this.trigger.addEventListener('mouseenter', () => this.open());
    this.menu.addEventListener('mouseenter',    () => this.cancelClose());
    this.menu.addEventListener('mouseleave',    () => this.scheduleClose());
    this.trigger.addEventListener('mouseleave', () => this.scheduleClose());

    // Click as fallback (touch devices)
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.isOpen ? this.close() : this.open();
    });

    // Backdrop click closes
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.close());
    }

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
        this.trigger.focus();
      }
    });

    // Re-position on scroll (sticky header support)
    window.addEventListener('scroll', () => {
      if (this.isOpen) this.updatePosition();
    }, { passive: true });

    // Keyboard: Enter/Space on trigger
    this.trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
        if (this.isOpen) {
          const first = this.menu.querySelector('.mega-menu-custom__column-header, .mega-menu-custom__topbar-shopall');
          if (first) first.focus();
        }
      }
    });
  }

  open() {
    this.cancelClose();
    if (this.isOpen) return;
    this.isOpen = true;
    this.updatePosition();
    this.menu.classList.add('is-open');
    this.trigger.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    if (this.backdrop) this.backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.cancelClose();
    if (!this.isOpen) return;
    this.isOpen = false;
    this.menu.classList.remove('is-open');
    this.trigger.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    if (this.backdrop) this.backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  scheduleClose() {
    this.cancelClose();
    this.closeTimeout = setTimeout(() => this.close(), 180);
  }

  cancelClose() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  updatePosition() {
    const header = this.closest('.header-wrapper')
      || this.closest('sticky-header')
      || this.closest('header');
    if (header) {
      const rect = header.getBoundingClientRect();
      this.menu.style.setProperty('--mega-menu-top', `${rect.bottom}px`);
    }
  }
}

customElements.define('mega-menu-custom', MegaMenuCustom);
